import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { MenuItem } from '../../../base/models/menu-items';

@Component({
  selector: 'app-mega-menu-block',
  templateUrl: './mega-menu-block.component.html',
  styleUrls: ['./mega-menu-block.component.scss']
})
export class MegaMenuBlockComponent implements OnInit {
  @Input() menuItems: MenuItem[]
  @Input() code: string

  @Output() onItemClick = new EventEmitter<void>();

  constructor() { }

  ngOnInit() {
  }

  get menu(): MenuItem {
    if (this.menuItems && this.menuItems.length && this.code) {
      return this.menuItems.find(menu => menu.code === this.code)
    }
  }

  get hasChildren(): boolean {
    return !!(this.menu.children && this.menu.children.length)
  }

  get children(): MenuItem[] {
    return this.menuItems.filter(menu => menu.parent === this.menu.code)
  }

  public onClick(): void {
    this.onItemClick.emit()
  }
}
